// Obs.: o backend grava as datas com o horário de Brasília "como se fosse UTC"
// (getCurrentDateInBrasilia). Por isso aqui as datas são lidas direto da string
// ISO / dos campos UTC, sem converter para o fuso do aparelho.

export const formatDate = (isoDateString: string) => {
  // Mantém os primeiros 19 caracteres e substitui 'T' por espaço
  const localDateString = isoDateString.substring(0, 19).replace("T", " ");

  // Quebra em partes
  const [datePart, timePart] = localDateString.split(" ");
  const [year, month, day] = datePart.split("-");

  // Retorna no formato dd/mm/yyyy HH:mm:ss
  return `${day}/${month}/${year} ${timePart}`;
};

// HH:mm
export const formatTime = (isoDateString: string) =>
  isoDateString.substring(11, 16);

// YYYY-MM-DD -> dd/mm
export const formatShortDay = (isoDay: string) => {
  const [, month, day] = isoDay.split("-");
  return `${day}/${month}`;
};

const BRASILIA_OFFSET_MS = 3 * 60 * 60 * 1000;

// Dia de hoje em Brasília (YYYY-MM-DD), independente do fuso do aparelho
export const todayInBrasilia = () =>
  new Date(Date.now() - BRASILIA_OFFSET_MS).toISOString().slice(0, 10);

// Soma (ou subtrai) dias de um YYYY-MM-DD
export const shiftDay = (isoDay: string, days: number) => {
  const date = new Date(`${isoDay}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
};

const WEEKDAYS = ["dom.", "seg.", "ter.", "qua.", "qui.", "sex.", "sáb."];
const MONTHS = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

// Rótulo do agrupamento por dia: "Hoje", "Ontem" ou "sex., 26 set"
// (com o ano quando não for o ano atual)
export const formatDayLabel = (isoDay: string) => {
  const today = todayInBrasilia();
  if (isoDay === today) return "Hoje";
  if (isoDay === shiftDay(today, -1)) return "Ontem";

  const date = new Date(`${isoDay}T00:00:00.000Z`);
  const label = `${WEEKDAYS[date.getUTCDay()]}, ${date.getUTCDate()} ${
    MONTHS[date.getUTCMonth()]
  }`;
  const year = isoDay.slice(0, 4);

  return year === today.slice(0, 4) ? label : `${label} ${year}`;
};
